import React, { useEffect, useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { Create_Api } from '../../API_URL';
import { toast } from 'react-toastify';

const CollaborateSection = () => {

    const [FirstName, setFirstName] = useState('');
    const [LastName, setLastName] = useState('');
    const [Email, setEmail] = useState('');
    const [Number, setNumber] = useState('');
    const [Company, setCompany] = useState('');
    const [Message, setMessage] = useState('');
    const [IsLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState("");


    const [num1, setNum1] = useState(0);
    const [num2, setNum2] = useState(0);
    const [captchaValue, setCaptchaValue] = useState("");
    const [captchaError, setCaptchaError] = useState("");


    const generateCaptcha = () => {
        const a = Math.floor(Math.random() * 9) + 1;
        const b = Math.floor(Math.random() * 9) + 1;
        setNum1(a);
        setNum2(b);
        setCaptchaValue("");
        setCaptchaError("");
    };

    useEffect(() => {
        generateCaptcha();
    }, []);

    const CreateContactUs = async () => {

        if (parseInt(captchaValue) !== num1 + num2) {
            setCaptchaError("Captcha is incorrect");
            return;
        }

        setCaptchaError("");

        let newErrors = {};

        if (!FirstName.trim()) newErrors.FirstName = "FirstName is required";
        if (!LastName.trim()) newErrors.LastName = "LastName is required";
        if (!Email.trim()) newErrors.Email = "Email is required";
        if (!Number.trim()) newErrors.Number = "Number is required";

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        const payload = {
            FirstName,
            LastName,
            Email,
            PhoneNumber: Number,
            Company,
            Enquiry: "Glodesk",
            Message
        };

        try {
            setIsLoading(true);
            const response = await Create_Api("api/admin/CreateContactus", payload);
            if (response?.data) {
                // toast.success("Your message has been received. We’ll get back to you as soon as possible.");
                setSuccessMessage(
                    "Your message has been received. We’ll get back to you as soon as possible."
                );
                setFirstName("");
                setLastName("");
                setEmail("");
                setNumber("");
                setCompany("");
                setMessage("");
                generateCaptcha();
            } else {
                toast.error(response?.message || "Failed to upload requirement");
            }
        } catch (error) {
            console.error("Error uploading requirement:", error);
            toast.error(error?.response?.message || "Failed to upload requirement");
        } finally {
            setIsLoading(false);
        }
    };




    const inputStyles = "w-full bg-transparent border-0 border-b border-gray-300 py-3 text-gray-700 placeholder:text-gray-400 focus:ring-0 focus:border-[#F06115] outline-none transition-colors shadow-none rounded-none font-outfit";

    return (
        <section className="relative w-full flex justify-center flex-col overflow-hidden">
            <div className="max-w-[1440px] w-full mx-auto flex lg:flex-row flex-col px-6 lg:px-[80px] relative z-10">
                <div className="bg-[#F0F0F0] max-w-[858px] w-full p-8 lg:p-[30px]">

                    <h2 className="text-[#0F3460] text-[20px] lg:text-[30px] font-[600] font-sora mb-6 tracking-tight">
                        Let’s Collaborate
                    </h2>

                    <div className="lg:space-y-[24px] space-y-[16px]">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-y-[24px]">

                            <div className="group">
                                <label className="text-[14px] text-[#01386A] duration-300 font-outfit font-[400]">
                                    First Name <span className="text-orange-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    placeholder="Enter your first name"
                                    className={inputStyles}
                                    value={FirstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                                {errors?.FirstName && (
                                    <span className="text-red-500 text-sm">{errors?.FirstName}</span>
                                )}
                            </div>

                            {/* Last Name */}
                            <div className="group">
                                <label className="text-[14px] text-[#01386A] duration-300 font-outfit font-[400]">
                                    Last Name <span className="text-orange-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    placeholder="Enter your Last name "
                                    className={inputStyles}
                                    value={LastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                                {errors?.LastName && (
                                    <span className="text-red-500 text-sm">{errors?.LastName}</span>
                                )}
                            </div>

                        </div>

                        {/* --- Row 2: Email & Phone --- */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
                            <div className="group">
                                <label className="text-[14px] text-[#01386A] duration-300 font-outfit font-[400]">
                                    Email <span className="text-orange-500">*</span>
                                </label>
                                <input
                                    type="email"
                                    placeholder="Enter your Email"
                                    className={inputStyles}
                                    value={Email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                {errors?.Email && (
                                    <span className="text-red-500 text-sm">{errors?.Email}</span>
                                )}
                            </div>

                            {/* Phone */}
                            <div className="group">
                                <label className="text-[14px] text-[#01386A] duration-300 font-outfit font-[400]">
                                    Phone <span className="text-orange-500">*</span>
                                </label>
                                <input
                                    type="tel"
                                    placeholder="Enter your Phone number"
                                    className={inputStyles}
                                    value={Number}
                                    onChange={(e) => setNumber(e.target.value)}
                                />
                                {errors?.Number && (
                                    <span className="text-red-500 text-sm">{errors?.Number}</span>
                                )}
                            </div>

                        </div>

                        {/* --- Row 3: Message --- */}
                        <div className="group">
                            <label className="text-[14px] text-[#01386A] duration-300 font-outfit font-[400]">
                                Your Message <span className="text-orange-500">*</span>
                            </label>
                            <textarea
                                rows="1"
                                placeholder="Enter Your Message"
                                className={`${inputStyles} resize-none`}
                                value={Message}
                                onChange={(e) => setMessage(e.target.value)}
                            ></textarea>
                        </div>

                        {/* --- Submit Button --- */}

                        <div className="md:col-span-2 mt-4">

                            {successMessage && (
                                <div className="mb-4 p-4 bg-green-50 border border-green-300 text-green-700 rounded-md">
                                    {successMessage}
                                </div>
                            )}

                            <button
                                onClick={CreateContactUs}
                                className="flex items-center gap-2 px-8 py-3 border border-[#ED6800] text-[#ED6800] font-[600] text-[16px] font-graphik hover:bg-[#ED6800] hover:text-white transition-all duration-300 group"
                            >
                                {IsLoading ? "Please Wait" : "Submit"}
                                <ChevronRight size={20} className="transition-transform duration-300 group-hover:translate-x-1" />
                            </button>
                        </div>


                    </div>
                </div>
                <div className="max-w-[585px] w-full">
                    <img src="/assets/hospital/img2.png" alt="" />
                </div>
            </div>
        </section>
    );
};

export default CollaborateSection;